import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { COLOR, INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export const TransparentPrimaryButton = ({
  title = '',
  iconPosition = IconPositions.Left,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_25,
  paddings = [
    INDENTS.INDENT_30,
    INDENTS.INDENT_60,
    INDENTS.INDENT_30,
    INDENTS.INDENT_60,
  ],
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorHovered: _unused = ButtonColors.ACCENT_TERTIARY,
  colorDisabled = ButtonColors.COLOR_TEXT_TERTIARY,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorHovered = COLOR.TRANSPARENT,
  backgroundColorPressed = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.FontSmBold,
  fluid = ButtonFluid.None,
  ...rest
}: IButtonProps): JSX.Element => {
  return (
    <Button
      iconPosition={iconPosition}
      iconSize={iconSize}
      corners={corners}
      paddings={paddings}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorHovered={backgroundColorHovered}
      backgroundColorPressed={backgroundColorPressed}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      title={title}
      {...rest}
    />
  )
}
